

















































































import DragLayout from './components/DragLayout.vue'
import Aside from '@/components/aside/Index.vue';
import prettier from 'prettier/standalone';
import parserHtml from 'prettier/parser-html';
import { Component, Vue, Watch } from 'vue-property-decorator';
import mixins from '@/mixins';
import { State } from 'vuex-class';
import { LowElement } from './types/Element';
import Clipboard from 'v-clipboard'
import tinykeys from 'tinykeys';

Vue.use(Clipboard);

@Component({
  components: {
    'drag-layout': DragLayout,
    'low-aside': Aside
  },
  mixins: [mixins],
})
export default class App extends Vue {

  private created () {
    this.$store.dispatch('init');
    // localStorage.removeItem('preview');
    //
    tinykeys(window, {
      "$mod+z": () => {
        this.$store.commit('page/UNDO');
      },
      "$mod+Shift+z": () => {
        // 反撤回
        this.$store.commit('page/REDO');
      },
      "$mod+d": event => {
        event.preventDefault()
        if (typeof this.$store.state.page.currentId === 'undefined') return;
        this.$store.commit("page/REMOVE_CURRENT");
        this.$store.commit("page/SET_CURRENT", undefined);
      }
    })
  }

  refresh: boolean = false;

  isMove: boolean = false;
  currentId: string | number | null = null;
  // @State('elements')
  // elements: any;

  // @Watch('$store')
  // elementsWatch(){
  //   console.log(1);
  // }

  get elements () {
    return this.$store.state.page.elements;
  }
  set elements (val) {
  }


  show: boolean = !!localStorage.getItem('preview');;

  code: string = '';

  showCode: boolean = false;

  handleChangeShow () {
    this.show = !this.show;
    if (this.show) {
      localStorage.setItem('preview', 'true');
      // 直接整体更新一下sotre 同时强制更新一下更新视图
      this.$store.dispatch("page/refresh")
      this.refresh = true;
      this.$nextTick(() => {
        this.refresh = false;
      })
    } else {
      localStorage.removeItem('preview');
    }
  }
  async handleClearCanvas () {
    await this.$confirm(`是否确认清除画布？`);
    await this.$store.dispatch('page/clear_canvas');
    this.$notify.success('清除成功');
  }
  handleShowCodeData () {
    function generate (item: LowElement) {
      const props = item.props || {};
      const tagName = `el-${item.element}`;

      let children: string = (item.children || []).map(item => {
        return generate(item);
      }).join('\n');

      if (children) {
        children = '\n' + children + '\n';
      }
      const atter = Object.keys(props).filter(key => props[key]).reduce((pv: string, key: string) => {

        const value = JSON.stringify(props[key]);

        pv += ` :${key}='${value}'`

        return pv;
      }, '');
      const element = `<${tagName} ${atter}>${children}</${tagName}>`;

      return element;
    }
    const code = prettier.format(generate(this.$store.state.page.elements), {
      parser: "html",
      plugins: [parserHtml],
    });

    this.code = code;
    this.showCode = true;

  }

  // handle

}
